import { defineNuxtPlugin } from '#imports'
import { getTheme } from '@b2ag/app-brands'
import { getCookie, setCookie } from '@b2ag/utils/src/cookies'

export default defineNuxtPlugin({
  name: 'runtime theme',
  setup(nuxtApp) {
    // @ts-expect-error : The store isn't typed (at all)
    nuxtApp.$store.watch(
      (state: { user: { currentProfile?: { cooperative?: { id?: string | number } } } }) =>
        state.user.currentProfile?.cooperative?.id,
      (partnerId: string | number) => {
        if (!partnerId) return
        const expectedTheme = getTheme({ partnerId: String(partnerId) })
        const currentThemeCookie = getCookie('current_theme')
        if (!currentThemeCookie || currentThemeCookie !== expectedTheme) {
          setCookie('current_theme', expectedTheme, 5)
          window.location.reload()
        }
      },
      { immediate: true },
    )
  },
})
